import { AST } from '../ast';
import {
  ExprMacroChildren,
  RelMacroChildren,
  MacroVarReplacements,
} from '../ast/base';
import { Expression, Relation, Markup } from '../builder';
import _ from 'lodash';

export const callRelMacro = (
  macro: AST.RelFR,
  vars: Partial<MacroVarReplacements<RelMacroChildren>>,
  opts: { scope: string }
): Relation => {
  const called: AST._MacroApplyVarsToRel<RelMacroChildren> = {
    t: 'macro-apply-vars-to-rel',
    vars: pickFreeVars(Relation.wrap(macro).freeVars[opts.scope] ?? {}, vars),
    scope: opts.scope,
    sources: { from: macro },
    displayName: null,
  };

  return Relation.fromAst(called, { jsStackPointer: callRelMacro });
};

export const callExprMacro = (
  macro: AST.ExprFR,
  vars: Partial<MacroVarReplacements<RelMacroChildren>>,
  opts: { readonly scope: string }
): Expression => {
  const called: AST._MacroApplyVarsToExpr<ExprMacroChildren> = {
    t: 'macro-apply-vars-to-expr',
    vars: pickFreeVars(
      Expression.fromAst(macro).freeVars[opts.scope] ?? {},
      vars
    ),
    scope: opts.scope,
    sources: { from: macro },
    displayName: null,
  };

  return Expression.fromAst(called, { jsStackPointer: callExprMacro });
};

export const callMuMacro = (
  macro: AST.Mu,
  vars: Partial<MacroVarReplacements<RelMacroChildren>>,
  opts: { scope: string }
): Markup => {
  const called: AST._MacroApplyVarsToMarkup = {
    t: 'macro-apply-vars-to-markup',
    vars: pickFreeVars(Markup.fromAst(macro).freeVars[opts.scope] ?? {}, vars),
    scope: opts.scope,
    section: macro,
    displayName: null,
  };

  return Markup.fromAst(called, { jsStackPointer: callMuMacro });
};

const pickFreeVars = (
  needed: Partial<AST.MacroArgsType>,
  provided: Partial<AST.MacroVarReplacements<AST.RelMacroChildren>>
): AST.MacroVarReplacements<AST.RelMacroChildren> => {
  const { rels = {}, exprs = {}, sections = {} } = provided;

  return {
    rels: _.pickBy(rels, (_val, key) => needed.rels?.[key] !== undefined),
    exprs: _.pickBy(exprs, (_val, key) => needed.exprs?.[key] !== undefined),
    sections: _.pickBy(
      sections,
      (_val, key) => needed.sections?.[key] !== undefined
    ),
  };
};
